export const index = {
  namespaced: null,
  state: {},
  mutations: {},
  actions: {},
  getters: {},
};
